import { type RouteRecordRaw } from 'vue-router'

export const ScenesRouter: RouteRecordRaw[] = [
  {
    path: '/scenes',
    component: async () => import('./Scenes.vue'),
  },
]
